import React from 'react';

class Hero extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { details } = this.props;
        return (
            <section className="section">
                <div className="mole__hero">
                    <figure>
                        <img src={details.banner_image.url} alt={details.post_title} />
                        <figcaption className="hide-on-small-device">
                            <div className="main-container">
                                <h2 className="font-lg-head c-general">{details.post_title}</h2>
                            </div>
                        </figcaption>
                    </figure>
                </div>
            </section>
        );
    }
}
export default Hero;



// WEBPACK FOOTER //
// ./src/components/Projects/Marmalade/Hero.js